<template>

<basic-content>
<div slot="content" style="text-align:left; padding: 20px 0px 20px 0px">
<p>欢迎使用爱助手，在您使用爱助手提供的各项服务（以下简称“服务”）之前，请务必仔细阅读并透彻理解本协议。</p>
<p>如您不同意本协议及其更新内容，您可以主动取消爱助手提供的服务；您一旦使用爱助手的服务，即视为您已了解并完全同意本协议的各项内容，并成为爱助手用户（以下简称“用户”）。爱助手有权在必要时修改用户协议，协议一旦发生变动，将会以网站公告的形式提示修改内容，变动结果将在爱助手通知之日起生效。如果您不同意所改动的内容，您有权停止使用爱助手的服务，如果您继续使用爱助手的各项服务，则视为接受服务条款的变动。爱助手保留修改或中断服务的权利。</p>

<h3>爱助手服务</h3>
<p>爱助手接受用户委托、基于用户指令提供包括但不限于企业信息、互联网信息、特定数据库等查询服务。除非另有明确规定，增加或强化目前服务的任何新功能，包括新产品以及新增加的服务，均无条件地适用本协议。</p>
<p>爱助手提供的服务除部分特定说明收费的以外均为免费服务。用户使用免费查询服务时不必向爱助手支付任何费用。对于收费的服务，爱助手在您使用之前会给予明确的提示，只有您根据提示确认其愿意支付相关费用后，才能使用该等收费服务。如您未支付相关费用，则爱助手将不向您提供该收费服务。</p>
<p>您充分理解，在使用爱助手时所产生的网络服务有关的设备及所需的费用（如为使用移动网络而支付的手机费、流量费等各项费用）均应由您自行负担。</p>

<h3>爱助手帐户</h3>
<p>“爱助手帐户”是指您通过爱助手的产品或网站注册的帐户，爱助手所提供的部分服务需要您在登录您的爱助手帐户之后使用。除本协议外，爱助手发布的其他相关的业务规则也是本协议的一部分，请您仔细阅读。</p>

<h3>用户注册</h3>
<p>爱助手账号的所有权归爱助手所有，您完成申请注册手续后，将获得所注册账号的使用权，该使用权仅限于您使用，您无权赠与、借用、租用、转让或售卖您的账号。</p>
<p>用户应当妥善保管账户及密码信息，由于用户自身行为导致的账户或密码的泄露、遗忘等情形或其他原因所带来的损失，爱助手将尽量配合用户采取积极措施降低相关损失，但因此造成的不利后果由用户自行承担。</p>

<h3>使用规范</h3>
<p>您在使用爱助手时必须遵守国家有关法律规定，并承担一切因自己发布信息不当导致的民事、行政、或刑事法律责任。</p> 
<p>您使用爱助手所记录或发布的消息，不得含有以下内容或用于以下目的：</p>
<ul>
<li>违反宪法确定的基本原则的；</li>
<li>危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一的；</li>
<li>损害国家荣誉和利益，攻击党和政府的；</li>
<li>煽动民族仇恨、民族歧视，破坏民族团结的；</li>
<li>破坏国家、地区间友好关系的；</li>
<li>违背中华民族传统美德、社会公德、论理道德、以及社会主义精神文明的；</li>
<li>破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
<li>散布谣言或不实消息，扰乱社会秩序，破坏社会稳定的；</li>
<li>煽动、组织、教唆恐怖活动、非法集会、结社、游行、示威、聚众扰乱社会秩序的；</li>
<li>散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</li>
<li>侮辱或诽谤他人，侵害他人合法权益的；</li>
<li>侵犯他人肖像权、姓名权、名誉权、隐私权或其他人身权利的；</li>
<li>以非法民间组织名义活动的；</li>
<li>侵犯他人著作权等合法权益的；</li>
<li>侵犯他人商业秘密等合法权益的；</li>
<li>含有法律、行政法规禁止的其他内容的；</li>
<li>为任何非法目的而使用爱助手服务，包括但不限于利用爱助手从事以下活动：</li>
<ul>
<li>对爱助手相关服务任何部分或本服务之使用或获得，进行复制、出售、转售或用于任何其它商业目的；</li>
<li>未经书面允许，进入计算机信息网络或者使用计算机信息网络资源的；</li>
<li>未经书面允许，对计算机信息网络功能进行删除、修改或者增加的；</li>
<li>未经书面允许，进入计算机信息网络中对存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；</li>
<li>故意制作、传播计算机病毒（包括木马）等破坏性程序；</li>
<li>其他危害计算机信息网络安全的行为</li>
</ul>
</ul>

<p>如果您在使用爱助手所提供的的服务时不能履行和遵守协议中的规定，爱助手可以在任何时候、不经事先通知单方面终止本协议，并可以采取包括删除您发布的相关信息、封闭您的账号、临时或永久禁止您使用爱助手服务等相关措施，同时保留依法追究您法律责任的权利。爱助手保留将系统内有可能作为您违反法律和本协议证据的记录与数据加以保存与展示的权利。</p>

<p>因用户提供的内容违法或侵犯第三人的合法权益而导致爱助手对第三方承担任何性质的赔偿、补偿或罚款而遭受损失(包括但不限于直接的、间接的、偶然的、惩罚性的损失)，用户对于爱助手遭受的上述损失承担完全的赔偿责任。</p>

<p>未经爱助手书面许可，任何单位或个人不得通过任何方式（包括但不限于恶意注册爱助手账号，机器抓取、复制、镜像等方式）不合理地获取爱助手站内信息、资讯、数据等。</p>

<h3>隐私政策</h3>
<p>爱助手尊重并保护所有使用爱助手服务用户的个人隐私。为了给您提供更加准确、更个性化的服务，爱助手会按照本隐私政策的规定使用和披露您的个人信息。但爱助手将以高度的勤勉、审慎的态度对待您的个人信息。除非有法律和政府的强制规定，在事先未征得您许可或者授权的情况下，爱助手不会将您的信息对外披露或者向第三方提供。爱助手会不时更新本隐私政策。您在同意爱助手用户协议之时，即视为您已经同意本隐私政策全部内容。本隐私权政策属于爱助手用户协议不可分割的一部分。</p>

<h4>1. 适用范围</h4>
<ul>
<li>在您注册爱助手账户时，您根据爱助手要求提供的个人或组织注册信息；</li>
<li>在您使用爱助手服务，或访问爱助手网页时，爱助手自动接收并记录的您的浏览器和计算机上的信息，包括但不限于您的IP地址、浏览器的类型、使用的语言、访问日期和时间、软硬件特征信息及您需求的网页记录等数据；</li>
<li>爱助手通过合法途径从商业伙伴处取得的用户个人数据</li>
</ul>

<p>您了解并同意，以下信息不适用本隐私政策：</p>
<ul>
<li>您在使用爱助手提供的服务时，对外公布的信息；</li>
<li>信用评价、违反法律规定或违反爱助手规则行为及爱助手已对您采取的措施</li>
</ul>

<h4>2. 信息使用</h4>
<ul>
<li>爱助手不会向任何无关第三方提供、出售、出租、分享或交易您的个人信息，除非事先得到您的许可，或该第三方和爱助手（含爱助手关联公司）单独或共同为您提供服务，且在该服务结束后，其将被禁止访问包括其以前能够访问的所有这些资料；</li>
<li>爱助手亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播您的个人信息。任何爱助手用户如从事上述活动，一经发现，爱助手有权立即终止与该用户的服务协议；</li>
<li>为服务用户的目的，爱助手可能通过使用您的个人信息，向您提供您感兴趣的信息，包括但不限于向您发出产品和服务信息，或者与爱助手合作伙伴共享信息以便他们向您发送有关其产品和服务的信息（后者需要您的事先同意）</li>
</ul>
<h4>3. 信息披露</h4>
<p>在如下情况下，爱助手将依据您的个人意愿或法律的规定全部或部分的披露您的个人信息：</p>
<ul>
<li>经您事先同意，向第三方披露；</li>
<li>如您是适格的知识产权投诉人并已提起投诉，应被投诉人要求，向被投诉人披露，以便双方处理可能的权利纠纷；</li>
<li>根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</li>
<li>如您出现违反中国有关法律、法规或者爱助手服务协议或相关规则的情况，需要向第三方披露；</li>
<li>为提供您所要求的产品和服务，而必须和第三方分享您的个人信息；</li>
<li>在爱助手上创建的某一交易中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，爱助手有权决定向该用户提供其交易对方爱助手收集的有关您的的联络方式等必要信息，以促成交易的完成或纠纷的解决；</li>
<li>其它爱助手根据法律、法规或者网站政策认为合适的披露</li>
</ul>
<h4>4. 信息存储和交换</h4>
<p>信息和资料将保存在爱助手及（或）其关联公司的服务器上。</p>

<h4>5. Cookie</h4>
<ul>
<li>在您未拒绝接受cookie的情况下，爱助手会在您的计算机上设定或取用cookie，以便您能登录或使用依赖于cookie的爱助手服务或功能。爱助手使用cookie可为您提供更加周到的个性化服务，包括推广服务；</li>
<li>您有权选择接受或拒绝接受cookie。您可以通过修改浏览器设置的方式拒绝接受cookie。但如果您选择拒绝接受cookie，则您可能无法登录或使用依赖于cookie的爱助手服务或功能；</li>
<li>通过爱助手所设cookie所取得的有关信息，将适用本政策</li>
</ul>

<h4>6. 信息安全</h4>
<p>爱助手账户均有安全保护功能，请妥善保管您的账户及密码信息。爱助手将通过向其它服务器备份、对用户密码进行加密等安全措施确保您的信息不丢失，不被滥用和变造。尽管有前述安全措施，但同时也请您注意在信息网络上不存在绝对完善的安全措施。</p>
<p>在使用爱助手服务进行网上交易时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息泄密，尤其是爱助手账户及密码发生泄露，请您立即联络爱助手客服，以便爱助手采取相应措施。</p>


<h3>版权政策</h3>
<p>除非另行声明，爱助手的所有产品、技术、软件、程序、数据及其他信息（包括但不限于文字、图像、图表、版面设计、电子文档）的所有知识产权（包括但不限于版权、商标权、专利权、商业秘密）及相关权利，均归北京仝睿科技有限公司所有，在此并未授权任何第三方予以使用、复制或储存。“爱助手”及相关图形等为北京仝睿科技有限公司的注册商标。</p>
<p>爱助手尊重知识产权，反对侵权盗版行为。未经爱助手许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、镜像、上载、下载）使用，或通过非常规方式（如：恶意干预爱助手数据）影响爱助手的正常服务，任何人不得擅自以软件程序自动获得爱助手数据。否则，爱助手有权依法追究其法律责任。</p>
<p>未经爱助手许可，任何人禁止转载或商业使用爱助手网站内文字、图形、表格等信息，否则，爱助手保留采取一切合法方式维护正当利益的权利。经许可的信息的转载或商业使用时，应当以恰当方式说明，该信息来源于爱助手。</p>

<h3>权利通知</h3>

<p>鉴于免责声明中公示信息来源网站中的信息数据更新存在一定时间周期，因此任何援引免责申明中所示网站数据信息的展示行为，其信息数据均可能存在数据与客观情形存在一定偏差的情形，如果，该信息数据的偏差无法通过爱助手页面数据更新或其他功能加以纠正，且该信息关联方已经与该信息发布单位沟通并取得信息发布方书面更正文件，则该信息关联方有权以以下途径向爱助手发送权利声明以便爱助手对相关信息加以修正。</p>
<p>相关措施和步骤如下：</p>

<h4>1. 发出通知</h4>
<p>任何个人或组织如对爱助手内容存在异议，该个人或组织应以书面的方式向爱助手提交权利通知。发出权利通知时应当同时符合以下两个条件：</p>
<ul>
<li>权利人发现并可以证明爱助手所展示之内容侵犯了其合法权益；</li>
<li>爱助手以自动检索方式而产生并展示的内容侵犯了上述权利人的合法权益的信息经过网页内信息手动刷新按钮刷新或采取其他措施后仍然无法得到更正</li>
</ul>

<h4>2. 通知内容</h4>
<p>为了爱助手有效处理上述个人或单位的权利通知，请使用以下格式与内容的方式进行权利通知，否则，爱助手有权要求该权利通知发出者补充材料或拒绝作出修改：</p>
<ul>
<li>对任何权利提出的权利声明，都应提供相应完整的书面材料，以证明该权利的真实存在；</li>
<li>权利人对涉嫌侵权行为的相关内容拥有合法权利或其他依法可以行使该权利的权属证明；</li>
<li>权利通知应当充分、明确地描述被侵犯了权利人合法权益的具体内容并提供侵权信息展示页面的完整网页地址以及相关截屏资料；</li>
<li>权利声明需提供权利人具体的联络信息，包括但不限于：</li>
<ul>
<li>自然人的姓名、身份证或护照复印件；</li>
<li>企业或其他法人组织的单位登记证明复印件，该组织法定代表人身份证或护照复印件，如果该权利声明内容涉及除法定代表人以外的其他人员，还应当同时附有法定代表人委托书及被委托人身份证或护照复印件；</li>
<li>权利声明主体的通信地址、电话号码、传真及电子邮箱地址；</li>
<li>其他可以以书面或电子信息联系到权利声明方的联系方式</li>
</ul>
</li>
</ul>

<h4>3. 权利声明</h4>
<p>需加入如下关于通知内容真实性的声明：<p>
<ul>
<li>我本人（或我单位）是所投诉内容的合法权利人，或，我本人（或我单位）已获授权，有权行使本权利声明中列明内容的权益；</li>
<li>在我本人（或我单位）举报的爱助手页面上登载的内容侵犯了我本人（或我单位）相应的合法权益；</li>
<li>我本人（或我单位）保证，本通知中所述信息是充分、真实、准确的；</li>
<li>我本人（或我单位）确认：如果本权利通知内容不完全属实，我本人（或我单位）将承担由此产生的一切法律责任</li>
</ul>

<h4>4. 通知格式</h4>

<p>请以书面打印件形式制作权利声明，对权利声明的全部内容请权利人及该文件直接关联人员亲自在每页文件纸张上签署姓名并写明签署时间与用途，如果权利声明主体系依法成立的机构或组织，请您加盖该组织公章并由法定代表人亲自签署并写明签署时间与用途。</p>
<p>除前款要求书写内容以外，其他任何形式的涂抹、删改、修正或任何可能引起对该文件被修改产生合理怀疑的行为与情形均有可能导致该文件不被采纳，请务必注意。</p>

<h4>5. 通知送达</h4>

<p>请您把以上资料和联络方式以高清扫描件的形式发往以下电子邮件地址，我们会在收到您的来函并结合实情况予以回复：</p>
<p>收信地址：report#eton.ai (发送邮件时请将'#'替换为'@')</p>

<h4>6. 补充说明</h4>
<p>爱助手一贯高度重视知识产权、商业秘密与个人隐私的保护并遵守中国各项法律、法规和具有约束力的规范性文件。根据法律、法规和规范性文件要求，爱助手制定了旨在保护权利人的合法权益的措施和步骤，当权利人发现在爱助手生成的信息所展示的内容侵犯其合法权益时，权利人应事先向爱助手发出书面的“权利通知”，爱助手将根据中国法律法规和政府规范性文件采取措施移除相关内容或以其他技术手段加以处理。若关联方未以该方式发送权利声明，则爱助手有权拒绝对网站所示数据与信息的修改或技术处理。</p>
<p>如果您所发出的权利通知的陈述失实，权利通知提交者将承担对由此造成的全部法律责任（包括但不限于赔偿各种费用及律师费）。如果您无法确定网络上可获取的资料侵犯了何种法定权利，爱助手建议您首先咨询专业人士。</p>

<h3>免责声明</h3>
<p>爱助手是一款信息查询系统。根据用户指令，爱助手的搜索引擎系统会以非人工检索方式自动生成用户检索的已经依法公开的信息，以便用户能够找到和使用该已被公开信息。</p>
<p>爱助手提供的信息是爱助手基于公开数据经过技术手段处理形成的分析结果，特定情况下，爱助手无法核实该技术分析结果的真实性，并无法对此结果与客观实际情况的一致性负责，该结果仅可作为用户进行任何判断时的参考之一，若任何人通过使用该数据分析结果做出任何行为，该结行为相关权利义务由行为人自行承担。查询人必须依法使用查询信息，不得用于非法目的和不正当用途。非法使用本网站信息给他人造成损害的，由使用人自行承担相应责任。</p>
<p>爱助手自身不主动编辑或修改被所公示网站上的信息的内容或其表现形式，仅对相关网站依法公示的信息如实展示。因此，爱助手无法保证该数据与信息的完整的真实与时效性。同时，用户在使用爱助手时说明其已经理解并接受以下情形的免责声明：</p>
<ul>
<li>爱助手对由于用户不正当使用本网站服务、或依据本网站信息进行交易引起的对任何第三方的损害不承担任何赔偿责任；</li>
<li>本网站的内容及提供的服务不含任何明示性或暗示性的声明、保证或条件，包括但不限于关于真实性、适销性或适用于某一特定用途的明示或暗示性的声明、保证或条件，或者对其使用不会被中断或无误；</li>
<li>爱助手不声明或保证本网站或可从本网站下载的内容不带有计算机病毒或类似垃圾或破坏功能；</li>
<li>爱助手不担保本网站服务一定能满足用户的要求，不对页面内容的删除或储存失败负责；</li>
<li>若爱助手已经明示本网站运营方式发生变更并提醒用户应当注意事项，用户未按要求操作所产生的一切后果由用户自行承担；</li>
<li>已经注册为爱助手会员的用户，在超出会员服务范围外要求的其他服务可能会产生额外的费用由用户自己承担；</li>
<li>爱助手对由于政府禁令、现行生效的适用法律或法规的变更、火灾、地震、动乱、战争、停电、通讯线路中断、黑客攻击、计算机病毒侵入或发作、电信部门技术调整、因政府管制而造成网站的暂时性关闭等任何影响网络正常运营的不可预见、不可避免、不可克服和不可控制的事件（“不可抗力事件”），以及他人蓄意破坏、北京仝睿科技有限公司工作人员的过失疏忽或不当使用，正常的系统维护、系统升级，或者因网络拥塞而导致本网站不能访问而造成的本站所提供的信息及数据的延误、停滞或错误，使用者由此受到的一切损失不承担任何责任；</li>
<li>用户确认其知悉，对于爱助手提供的数据服务系统内容涉及根据法律法规或规范性文件需要数据查询或使用者获得数据相关方权利人授权的，用户及用户相关系统使用人员应当于数据查询与使用前自行获取相关权利人授权，尚未获得相关权利人授权而对相关信息进行查询与使用的，因此造成一切不利后果由用户自行承担；</li>
<li>用户知悉并同意，允许爱助手访问您的通讯录时，爱助手有权通过邮件、短信或电话等形式，向您及您授权的手机联系人发送会员活动相关信息；</li>
<li>用户确认其知悉由于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人信息的泄漏，或其他非因爱助手平台原因导致的个人信息的泄漏，爱助手概不负责；</li>
<li>用户确认其知悉，使用本网站提供的服务涉及到互联网服务和电信增值服务，可能会受到各个环节不稳定因素的影响。因此服务存在因国家相关行业主管部门及电信运营商的调整、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险。用户须承担以上风险，爱助手不作担保。对因此导致用户不能发送、上传和接受阅读消息、或接发错消息，或无法实现其他通讯条件，爱助手不承担任何责任；</li>
<li>用户确认其知悉，在使用本网站提供的服务存在有来自任何其他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯(包括知识产权)的匿名或冒名的信息的风险，用户须承担以上风险，对因此导致任何因用户不正当或非法使用服务产生的直接、间接、偶然、惩罚性的损害，不承担任何责任；</li>
<li>如果您不是具备完全民事权利能力和完全民事行为能力的自然人，您无权使用爱助手服务，因此爱助手希望您不要向我们提供任何个人信息</li>
</ul>

<h3>解决争议</h3>

<p>因使用爱助手的过程所产生的一切争议与纠纷若无法通过协商解决，则可以通过以下方式解决：双方首次就争议解决方法商洽开始30天后仍未就争议解决方式达成一致意见的，则应通过北京仝睿科技有限公司所在地有管辖权的人民法院诉讼解决。</p>
<p>因使用爱助手所引起的诉讼其程序及实体事宜受中华人民共和国法律管辖并按其进行解释。</p>
<p>就双方争议解决所产生的一切费用由诉讼的败诉方承担，该费用包括但不限于；冻结资产产生的费用与损失、调查取证费、诉讼费、律师费、工作人员差旅费及其他因诉讼产生的必要费用。</p>

<h3>接受声明</h3>
<ul>
<li>用户在使用爱助手前对本声明的条款已充分阅读，就声明的条款内容进行了充分沟通。用户已完整、清晰的理解每一条款的真实含义，对声明的条款约定的双方权利义务均不存在异议与保留意见；</li>
<li>双方在此确认就本声明的条款内容，不存在重大误解、欺诈胁迫等可能导致本声明的条款可撤销或自始无效等效力瑕疵事宜。明确放弃基于上述及类似理由产生的撤销权；</li>
<li>用户在使用爱助手网站或软件时即代表其已经声明基于真实有效的意思表示，接受本声明的条款；</li>
<li>本协议条款的最终解释权归北京仝睿科技有限公司所有</li>
</ul>
</div>
</basic-content>
</template>

<script>

import BasicContent from '@/layout/BasicContent.vue'

export default {
  name: 'UserAgreement',
  props: {
  },

  components: { 
    BasicContent
  }, 

  methods: {
  }
}
</script>

<style>
</style>
